import { map } from 'ramda';
import FormDropdown from 'components/FormDropdown';
import React, { useState, useEffect } from 'react';
import { DropdownItemProps } from 'semantic-ui-react';
import { defaultFormatter } from 'components/dropdowns/utils';
import { getAgeLevels } from 'actions/ageLevels';

const AgeLevels: React.FC = props => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<DropdownItemProps[]>([]);

  useEffect(() => {
    setLoading(true);
    getAgeLevels().then(({ data }) => {
      setOptions(map(defaultFormatter, data.age_levels));
      setLoading(false);
    });
  }, []);

  return <FormDropdown loading={loading} options={options} {...props} />;
};

export default AgeLevels;
